import { DEFAULT_COMMENT_TITLE } from '@library/formBuilder/blocks/comment/comment.data';
import type { TI_CommentData } from '@stratumn/studio-shared';

//? selectedVariable is set in the component on spawn using the selectedVariableRef from the block datInfo
export const initialTICommentData: Omit<TI_CommentData, 'selectedVariable'> = {
  title: DEFAULT_COMMENT_TITLE
};
